<template>
  <el-container>
      <div class="body">
        <el-row>
          <el-col :span="16">
            <div>
              <el-form>
                <el-form-item label="步骤:">
                  <el-input-number
                      size="small"
                      @change="updateData"
                      placeholder="请输入步骤"  :min="1" :max="100" :step="1" v-model="data.step"></el-input-number >
                </el-form-item>
                <el-form-item label="输出成片:">
                  <el-switch
                      active-text="开启"
                      :active-value="1"
                      :inactive-value="0"
                      inactive-text="关闭"
                      v-model="data.enOutput"
                      @change="updateData"
                     ></el-switch>
                </el-form-item>
                <el-form-item label="步骤说明:">
                  <el-input type="textarea" @change="updateData" placeholder="用简短的话介绍步骤"  :autosize="{ minRows: 2, maxRows: 4}" v-model="data.description"></el-input>
                </el-form-item>
                <el-form-item label="工作流:" style="margin-top: 10px">
                  <el-radio-group  @change="updateData" v-model="data.workflowId" @input="handleClickConfirm">
                    <el-radio v-for="(workflow,index) in list" :label="workflow.id"  :key="index" border>{{workflow.name}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <div>
                <el-tabs type="border-card" style="background-color: #f8f8f8;margin-top: 20px">
                  <el-tab-pane label="参数调整" >
                    <div style="padding: 20px">
                      <el-form label-width="140px" size="mini">
                        <el-form-item v-for="(item,index) in paramList" :label="item.label + ':'">
                          <el-input @change="updateData"  type="textarea"
                                     :rows="4"
                                     :autosize="{ minRows: 2, maxRows: 4}"
                                     :placeholder="'请输入' + item.label" v-if="item.type === 'text'" v-model="item.value"></el-input>
                          <el-input-number
                              @change="updateData"
                              :placeholder="'请输入' + item.label" v-if="item.type === 'num'" :min="item.min" :max="item.max" :step="item.step" v-model="item.value"></el-input-number >
                          <div v-if="item.type === 'img'" >
                            <div>
                              <el-switch
                                  active-text="其他步骤结果"
                                  inactive-text="上传图片"
                                  v-model="item.useOtherStep"
                                  @change="(e)=>{
                                useOtherChange(item.name)
                              }"></el-switch>
                            </div>
                            <div v-if="item.useOtherStep">
                              <el-radio-group v-model="item.useStep" @change="updateData">
                                {{item.useStep}}
                                <el-radio v-for="step in allSteps" :label="step.step"  :key="step.step" v-if="data.step !== step.step" border>步骤 {{step.step}}</el-radio>
                              </el-radio-group>
                            </div>
                            <upload-image v-else v-model="item.value" @change="(value) => {
              imgChange(index,value)
            }"></upload-image>
                            <div v-if="item.useOtherStep" style="width: 100px; height: 100px; background-color: #8f8f8f; border-radius: 20px; margin-top: 10px;display: flex;justify-content: center;align-items: center;font-size: 12px;color: #cccccc">
                              <div v-if="!item.value">
                                <span >
                                  <span v-if="item.useStep">等待步骤 {{item.useStep}} 完成</span>
                                  <span v-else>未选择步骤</span>
                                </span>
                              </div>

                              <el-image v-else :src="item.value" :fit="item.fit" style="width: 100px;height: 100px; border-radius: 20px;" :preview-src-list="[item.value]"></el-image>
                            </div>
                          </div>
                          <div v-if="item.type === 'inputImg'">
                            <div>
                              <el-switch
                                  active-text="其他步骤结果"
                                  inactive-text="使用输入照片"
                                  v-model="item.useOtherStep"
                                  @change="(e)=>{
                                useOtherChange(item.name)
                              }"></el-switch>
                            </div>
                            <div v-if="item.useOtherStep">
                              <el-radio-group v-model="item.useStep" @change="updateData">
                                <el-radio v-for="step in allSteps" :label="step.step"  :key="step.step" v-if="data.step !== step.step" border>步骤 {{step.step}}</el-radio>
                              </el-radio-group>
                            </div>
                            <div v-else>
                              <el-radio-group v-model="item.useStep" @change="inputChange(index)">
                                <el-radio v-for="(inputImg, inputImgIndex) in inputCount" :label="inputImgIndex"  :key="inputImgIndex"  border>输入 {{inputImgIndex + 1}}</el-radio>
                              </el-radio-group>
                            </div>
                            <div style="width: 100px; height: 100px; background-color: #8f8f8f; border-radius: 20px; margin-top: 10px;display: flex;justify-content: center;align-items: center;font-size: 12px;color: #cccccc">
                              <div v-if="!item.value">
                                <span v-if="item.useOtherStep">
                                  <span v-if="item.useStep">等待步骤 {{item.useStep}} 完成</span>
                                  <span v-else>未选择步骤</span>
                                </span>
                                <span v-else>未选择输入照片</span>
                              </div>
                              <el-image v-else :src="item.value" :fit="item.fit" style="width: 100px;height: 100px; border-radius: 20px;" :preview-src-list="[item.value]"></el-image>
                            </div>
                          </div>
                          <div v-if="item.type === 'seed'" style="display: flex">
                            <div style="width: 200px">
                              <el-input type="number" max="999999999999999" @change="updateData"  min="0" v-model="item.value" placeholder="请输入随机数"></el-input>
                            </div>
                            <el-button type="text" icon="el-icon-refresh" @click="()=>{
                            //   生成随机数
                              item.value = Math.floor(Math.random() * 999999999999999)
                            }" round></el-button>
                            <el-checkbox v-model="item.random" @change="updateData" >随机</el-checkbox>
                          </div>
                          <div v-if="item.type === 'option'">
                            <el-radio v-for="(opt,optIdx) in item.options"
                                      v-model="item.value"
                                      :label="opt.value"
                                      @change="updateData"
                                      :key="optIdx" border>{{opt.label}}</el-radio>
                          </div>
                          <div v-if="item.type === 'slider'" style="display: flex">
                             <el-slider style="width: 60%;padding-left: 10px"
                                        v-model="item.value"
                                        @change="updateData"
                                       :max="item.max" :min="item.min" :step="item.step"
                                        :marks="getMask(item)"
                             ></el-slider>
                             <div style="line-height: 40px;padding-left: 20px;color: #024f73;font-weight: 600">
                               {{item.value}}
                             </div>
                          </div>
                          <div v-if="item.type === 'weight_type'">
                            <el-select v-model="item.value" @change="updateData" placeholder="请选择">
                              <el-option
                                  v-for="item in weightTypeList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.type === 'ckpt'">
                            <el-select v-model="item.value" @change="updateData" placeholder="请选择">
                              <el-option
                                  v-for="item in checkpointList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.type === 'lora'">
                            <el-select v-model="item.value" @change="updateData" placeholder="请选择">
                              <el-option
                                  key="None"
                                  label="None"
                                  value="None">
                              </el-option>
                              <el-option
                                  v-for="item in loraList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.type === 'VAE'">
                            <el-select v-model="item.value" @change="updateData" placeholder="请选择">
                              <el-option
                                  v-for="item in vaeList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.type === 'sampler_name'">
                            <el-select v-model="item.value" @change="updateData" placeholder="请选择">
                              <el-option
                                  v-for="item in samplerNameList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </div>
                          <div v-if="item.type === 'scheduler'">
                            <el-select v-model="item.value" @change="updateData" placeholder="请选择">
                              <el-option
                                  v-for="item in schedulerList"
                                  :key="item"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </div>
                        </el-form-item>
                      </el-form>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>

            </div></el-col>
          <el-col :span="8">
            <div>
              步骤{{data.step}}预览 <el-button v-if="drawStatus === 2" type="text"  @click="draw" size="mini">重新生成</el-button>
            </div>
            <div class="gallery-ara">
              <div v-if="drawStatus !== 2 && drawStatus !== -2" class="mask">
                <div v-if="drawStatus === 0">
                  正在调度机器，前面还有<span style="color: #ff0000">{{queneCount}}</span>个任务在排队
                </div>
                <div v-if="drawStatus === 1">
                  已经获取到资源，正在生成...
                </div>
                <div v-if="drawStatus === -1">
                  正在提交...
                </div>
                <div style="color: red;" v-if="drawStatus === 3">
                  生成失败
                </div>
                <div v-if="drawStatus === 4">
                  等待步骤<span v-for="(step,inx) in waitIngSteps" >{{step}}<span v-if="inx !== waitIngSteps.length -1">,</span></span> 完成后会自动提交
                </div>
                <div v-if="drawStatus === 3">
                  <el-button type="text"  @click="draw" size="mini">重试</el-button>
                </div>
                <div v-if="drawStatus === 4">
                  <el-button type="text"  @click="cancelDraw" size="mini">取消</el-button>
                </div>
                <div v-if="drawStatus === 0">
                  <el-button type="text"  @click="removeQueue" size="mini">取消排队</el-button>
                </div>
                <div v-if="drawStatus === 0 || drawStatus === 1" style="width: 40%;">
                  <el-progress :percentage="waitTime" :show-text="false"></el-progress>
                </div>
                <div v-if="drawStatus === 0 || drawStatus === 1">
                  <span style="color: #1e84e8">{{waitTime}}</span> s
                </div>
              </div>
              <div  v-if="!res && drawStatus === -2" style="color: #999999;font-size: 12px">
                <el-button type="text"  @click="draw" size="mini">立即生成</el-button>
              </div>
              <div v-if="res" class="gallery">
                <div   v-for="(item,index) in res.outputUrls"  class="gallery-item">
                  <el-image :preview-src-list="res.outputUrls" :src="item">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" class="image-slot" style="color: red;">
                      生成失败<span class="dot">...</span>
                    </div>
                  </el-image>
                </div>
              </div>
            </div>
            <div v-if="drawStatus === 2" style="font-size: 13px;margin-top: 5px;color: #777777">
              已生成 共花费 <span style="color: #00afff">{{waitTime}}</span> s
            </div>
          </el-col>
        </el-row>

      </div>
  </el-container>
</template>
<script>
import {
  addWorkflowTheme,
  deleteQueue,
  executeWorkflow,
  getCheckpointList,
  getLoraList, getPortrait,
  getQueueInfo,
  getSamplerNameList,
  getSchedulerList,
  getVaeList, getWeightTypeList,
  getWorkflowInfo,
  getWorkflowList, getWorkflowThemeCategoryOptions, getWorkflowThemeInfo, updateWorkflowTheme
} from '@/api/merchant/service/project'
import loading from '@/libs/loading'
import UploadImage from '@/components/uploadImage/index.vue'
import { functions } from 'lodash/object'

/**
 * 富文本工具
 */

export default {
  name: ' AigcThemeStep',
  components: {
    UploadImage
  },
  props: {
    data: {
      type: Object,
      default: {
        description: '',
        step: 0
      }
    },
    allSteps: {
      type: Array,
      default: () => []
    },
    getInput: Function,
    inputImgList: {
      type: Array,
      default: () => []
    },
    inputCount: {
      type: Number,
      default: 1
    }
  },
  watch: {
    data: {
      handler: function (newVal, oldVal) {
      },
      deep: true
    },
    inputImgList: {
      handler: function (newVal, oldVal) {
        console.log('inputImgList', newVal)
        this.inputImgList = newVal
        this.paramList.forEach(item => {
          if (item.type === 'inputImg' && !item.useOtherStep && item.useStep != null) {
            item.value = newVal[item.useStep].url
          }
        })
      }
    }
  },
  data () {
    return {
      list: [],
      selectId: '',
      paramList: [],
      res: null,
      timer: null,
      activeName: 0,
      loading: null,
      categoryOptions: [],
      drawStatus: -2, // -2 未生成 0 排队中 1 生成中 2 生成成功 3 生成失败 4 等待其他步骤
      queneCount: 0,
      waitTime: 0,
      drawInfo: {},
      checkpointList: [],
      samplerNameList: [],
      loraList: [],
      vaeList: [],
      schedulerList: [],
      weightTypeList: [],
      portraitList: [],
      waitIngSteps: [] // 需要等待的步骤
    }
  },
  created () {
  },
  methods: {
    functions,
    updateInput (useOtherStep, step, imgs) {
      this.paramList.forEach(item => {
        if (item.type === 'inputImg') {
          if (useOtherStep && item.useOtherStep) {
            if (item.useStep === step) {
              item.value = imgs[0]
            }
          }
          if (!useOtherStep && !item.useOtherStep) {
            item.value = imgs[0]
          }
        }
        if (item.type === 'img' && item.useOtherStep) {
          if (item.useStep === step) {
            item.value = imgs[0]
          }
        }
      })
      this.$forceUpdate()
      //   如果当前状态是等待其他步骤 继续执行
      if (this.drawStatus === 4) {
        this.draw()
      }
    },
    getRes () {
      if (this.drawStatus === 2) {
        return this.res.outputUrls
      }
    },
    inputChange (idx) {
      let item = this.paramList[idx]
      item.value = this.inputImgList[item.useStep].url
      this.updateData()
    },
    updateData () {
      let data = this.data
      data.params = JSON.stringify(this.paramList)
      if (this.drawStatus === 2 && this.res) {
        data.exampleImgs = JSON.stringify(this.res.outputUrls)
      }
      data.needWaitOtherStep = this.waitIngSteps.length > 0 ? 1 : 0
      data.waitStep = this.waitIngSteps.join(',')
      console.log('data:', data)
      this.$emit('update:data', data)
    },
    useOtherChange (name) {
    //   从 paramList 中获取对应 name 的 param 并赋值给 param
      let param = this.paramList.find(item => item.name === name)

      // 获取 value
      if (param.useOtherStep) {
        this.waitIngSteps.push(param.useStep)
        param.value = ''
        if (param.useStep) {
          param.value = this.getInput(param.useOtherStep, param.useStep)
        }
      } else {
        // 从waitIngSteps中删除
        this.waitIngSteps = this.waitIngSteps.filter(item => item !== param.useStep)
        param.value = this.inputImgList[param.useStep].url
      }
      //   强制刷新 paramList
      this.$set(this.paramList, this.paramList.findIndex(item => item.name === name), param)
      this.updateData()
      this.$forceUpdate()
    },
    init (value) {
      let that = this
      getWorkflowList().then((res) => {
        that.list = res
        console.log('value------', value)
        if (value.workflowId) {
          console.log('value.params------', value)
          if (value.params) {
            this.paramList = JSON.parse(value.params)
            console.log('this.paramList:', this.paramList)
          }
        } else {
          that.handleClick(res[0].id)
          that.data.workflowId = res[0].id
        }
      })
      if (value.exampleImgs && value.exampleImgs.length) {
        console.log('value.exampleImgs', value.exampleImgs)
        this.drawStatus = 2
        this.res.outputUrls = JSON.parse(value.exampleImgs)
      }
      this.data = value
    },
    imgChange (index, value) {
      console.log('value', value)
      console.log('index', index)
      this.paramList[index].value = value
      // 强制刷新
      this.updateData()
      this.$forceUpdate()
    },
    getMask (item) {
      let mask = {}
      mask[item.min] = {
        style: {
          color: 'rgba(189,189,189,0.55)'
        },
        label: item.min + ''
      }
      mask[item.max] = {
        style: {
          color: 'rgba(189,189,189,0.55)'
        },
        label: item.max + ''
      }
      return mask
    },
    getList () {
      console.log('this.data', this.data)
      getSchedulerList().then((res) => {
        this.schedulerList = res
      })
      getCheckpointList().then((res) => {
        this.checkpointList = res
      })
      getSamplerNameList().then((res) => {
        this.samplerNameList = res
      })
      getLoraList().then((res) => {
        this.loraList = res
      })
      getVaeList().then((res) => {
        this.vaeList = res
      })
      getWeightTypeList().then((res) => {
        this.weightTypeList = res
      })
    },
    handleClickConfirm (label) {
      // 询问是否确认切换
      let that = this
      let selected = this.list.find(item => item.id === label)
      this.$confirm('是否切换到 [' + selected.name + '] 当前的参数配置可能会丢失', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.handleClick(label)
      })
    },
    handleClick (label) {
      console.log('label', label)
      let selected = this.list.find(item => item.id === label)
      let that = this
      // 调用接口
      that.paramList = JSON.parse(selected.params)
      that.paramList.forEach(item => {
        if (item.type === 'inputImg') {
          item.useOtherStep = false
          item.value = that.getInput(item.useOtherStep, item.useStep)
        }
      })
      that.updateData()
      that.$forceUpdate()
      console.log(this.paramList)
    },
    cancelDraw () {
      this.drawStatus = -2
    },
    draw () {
      let that = this
      // 检查是否需要等待其他步骤
      if (this.checkParams()) {
        that.drawStatus = 4
        return
      }
      that.drawStatus = -1
      that.waitTime = 0
      executeWorkflow(this.data.workflowId, '', this.paramList).then((res) => {
        if (res.promptId) {
          that.drawInfo.promptId = res.promptId
          that.drawInfo.serviceId = res.service.id
          that.setSeed(res.seed)
          that.timer = setInterval(() => {
            that.waitTime++
          }, 1000)
          if (res.service.queueCount === 0) {
            that.getInfo(res.promptId, res.service.id)
            that.drawStatus = 1
          } else {
            that.refreshQueueCount(res.promptId, res.service.id)
            that.queneCount = res.service.queueCount
            that.drawStatus = 0
          }
        }
      }
      ).catch(
        () => {
          that.drawStatus = 3
          clearInterval(that.timer)
        }
      )
    },
    checkParams () {
      this.waitIngSteps = []
      let paramList = this.paramList
      let needWait = false
      for (let i = 0; i < paramList.length; i++) {
        let param = paramList[i]
        if ((param.type === 'inputImg' || param.type === 'img') && param.useOtherStep) {
          param.value = this.getInput(param.useOtherStep, param.useStep)
          if (!param.value || !param.value.length) {
            //   设置绘图状态为 等待参数
            this.waitIngSteps.push(param.useStep)
            needWait = true
            console.log('等待参数:', param)
          }
        }
      }
      return needWait
    },
    refreshQueueCount (promptId, serviceId) {
      let that = this
      console.log('refreshQueueCount: ', serviceId)
      getQueueInfo(serviceId).then((res) => {
        let runningQueue = res.runningQueue
        let pendingQueue = res.pendingQueue
        if (runningQueue.length > 0 && runningQueue[0].promptId === promptId) {
          that.drawStatus = 1
          that.getInfo(promptId, serviceId)
        }
        if (pendingQueue.length > 0) {
          for (let i = 0; i < pendingQueue.length; i++) {
            if (pendingQueue[i].promptId === promptId) {
              that.drawStatus = 0
              that.queneCount = i + 1
              setTimeout(() => {
                that.refreshQueueCount(promptId, serviceId)
              }, 2000)
              break
            }
          }
        }
      }).catch(() => {
        that.drawStatus = 3
        clearInterval(that.timer)
      })
    },
    removeQueue () {
      let that = this
      deleteQueue(this.drawInfo.serviceId, [this.drawInfo.promptId]).then(res => {
        this.$message({
          type: 'success',
          message: '已取消'
        })
        this.drawStatus = -2
        clearInterval(that.timer)
      })
    },
    setSeed (seed) {
      this.paramList.forEach(item => {
        if (item.name === 'seed') {
          item.value = seed
        }
      })
    },
    getInfo (promptId, serviceId) {
      let that = this
      getWorkflowInfo(promptId, serviceId).then(
        (res) => {
          if (res && res.id) {
            that.res = res
            if (!res.outputUrls || res.outputUrls.length === 0) {
              //   弹窗提示生成失败
              that.$message.error('生成失败')
              that.drawStatus = 3
            } else {
              that.drawStatus = 2
              that.updateData()
              that.$emit('step-done', that.data.step, res.outputUrls)
            }
            //   删除定时器
            clearInterval(that.timer)
          } else {
            setTimeout(() => {
              that.getInfo(promptId, serviceId)
            }, 2000)
          }
        }
      ).catch((res) => {
        console.log('getWorkflowInfo error', res)
        setTimeout(() => {
          that.getInfo(promptId, serviceId)
        }, 5000)
      })
    }
  },

  mounted () {
    this.init(this.data)
    this.getList()
  }
}
</script>
<style scoped>

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  background: #ccc;
  z-index: 999;
}
.mask div {
   margin-top: 10px;
}

.gallery-ara {
  position: relative;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  border: 2px solid #ccc;
  background: #f6f6f6;
  border-radius: 12px;
}

.header {
  position: fixed;
  background-color: white;
  width: 100%;
  z-index: 999;
  height: 60px;
  font-size: 16px;

  border-bottom: 1px solid rgba(189, 189, 189, 0.55)
}

.body {
  width: 100%;
  padding: 40px;
}
#chart {
  width: 100%;
  min-height: 500px;
  margin-top: 20px;
  margin-left: 40px;
}
.gallery {
  display: flex;
  flex-wrap: wrap;
}
.gallery img {
  margin: 5px;
  max-width: 100%; /* 计算每张图片的最大宽度 */
  height: auto;
}
.gallery-item {
  flex: 1 0 30%; /* 每行显示三个图片，计算方式：100% / 3 - 一点边距 */
  margin: 2px;
  box-sizing: border-box;
}

.draggable-element {
  position: fixed;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background-color: #fff;
  padding: 40px;
  left: 60px;
  top: 50%;
  cursor: move;
  z-index: 999;
}
.disDiv {
  /* display: flex; */
  border: 1px dotted;
  padding-bottom: 20px;
}
</style>
